import {Action} from '@ngrx/store';
import {Order, SelectedItem} from '../models/order';
import {type} from '../../shared';

export const ordersSelectedActionTypes = {
  LOAD: type('[order] Load orders selected'),
  LOAD_SUCCESS: type('[order] Load orders selected Success'),
  LOAD_FAIL: type('[order] Load orders selected Fail'),
  CLEAR: type('[order] Clear orders selected'),
};

export class LoadOrdersSelectedAction implements Action {
  readonly type = ordersSelectedActionTypes.LOAD;
  constructor(public payload?: SelectedItem[]) {}
}

export class LoadOrdersSelectedSuccessAction implements Action {
  readonly type = ordersSelectedActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Order[]) {}
}

export class LoadOrdersSelectedFailAction implements Action {
  readonly type = ordersSelectedActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class ClearOrdersSelectedAction implements Action {
  readonly type = ordersSelectedActionTypes.CLEAR;
  constructor() {}
}

